import LegalLayout from './LegalLayout';

export default function TermsOfUse() {
  return (
    <LegalLayout title="Terms of Use">
      <h1 className="text-3xl font-bold mb-4 text-orange-300">Terms of Use</h1>
      <p className="mb-4"><b>Last updated: May 2025</b></p>
      <p className="mb-4">
        By accessing or using the MockWit.ai website (“Service”), you agree to be bound by these Terms of Use. If you do not agree with any part, please do not use our Service.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Use of Service</h2>
      <ul className="list-disc list-inside mb-4">
        <li>You may use this website for lawful purposes only.</li>
        <li>You must not misuse the Service, attempt unauthorized access, or engage in activity that harms us or others.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Intellectual Property</h2>
      <p className="mb-4">
        All content, branding, and intellectual property on MockWit.ai is owned by us or our licensors. Do not copy, distribute, or use for commercial purposes without permission.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Disclaimers</h2>
      <ul className="list-disc list-inside mb-4">
        <li>This site is provided “as is” without warranties of any kind.</li>
        <li>We are not liable for any damages resulting from use of the Service.</li>
      </ul>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Modifications</h2>
      <p className="mb-4">
        We may update these Terms at any time. Continued use means you accept any changes.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Governing Law</h2>
      <p className="mb-4">
        These Terms are governed by the laws of Ontario, Canada, without regard to its conflict of law provisions.
      </p>
      
      <h2 className="text-xl font-semibold mt-6 mb-2 text-cyan-300">Contact</h2>
      <p>
        Questions? Email <a className="text-orange-300 underline" href="mailto:support@mockwit.ai">support@mockwit.ai</a>.
      </p>
    </LegalLayout>
  );
}
